import React from 'react'

export default function Field(props) {
  return (
    <div className='config-overview-bar__field'>
      {props.title !== null ? <div className='config-overview-bar__field-title'>{props.title}</div> : null}
      {props.children}
      {props.text !== null ? <div className='config-overview-bar__field-text'>{props.text}</div> : null}
    </div>
  )
}

Field.defaultProps = {
  title: null,
  text: null
}
